import { render, staticRenderFns } from "./SummaryRecordPlayerSelf.vue?vue&type=template&id=774b5850&scoped=true"
import script from "./SummaryRecordPlayerSelf.vue?vue&type=script&lang=js"
export * from "./SummaryRecordPlayerSelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b5850",
  null
  
)

export default component.exports